import React, { useEffect, useState } from "react";
import { Row, Col, FormGroup, Label, Input } from "reactstrap";
import axiosInstance from "../axios";

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);

  const [filters, setFilters] = useState({
    user: "",
    org: "",
    template: "",
    date: "",
  });

  useEffect(() => {
    axiosInstance
      .get("/notifications")
      .then((res) => {
        setNotifications(res);
      })
      .catch((err) => console.error("Failed to load notifications:", err))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    applyFilters();
  }, [filters, notifications]);

  const applyFilters = () => {
    const { user, org, template, date } = filters;
    let result = [...notifications];

    if (user) {
      result = result.filter((n) => n.user?.id === parseInt(user));
    }
    if (org) {
      result = result.filter((n) => n.user?.organization?.id === parseInt(org));
    }
    if (template) {
      result = result.filter((n) => n.template_name === template);
    }
    if (date) {
      const selectedDate = new Date(date);
      result = result.filter((n) => {
        const createdAt = new Date(n.created_at);
        return (
          createdAt.getFullYear() === selectedDate.getFullYear() &&
          createdAt.getMonth() === selectedDate.getMonth() &&
          createdAt.getDate() === selectedDate.getDate()
        );
      });
    }

    setFiltered(result);
  };

  const uniqueUsers = [
    ...new Map(notifications.map((n) => [n.user?.id, n.user])).values(),
  ].filter(Boolean);
  const uniqueOrgs = [
    ...new Map(
      notifications.map((n) => [n.user?.organization?.id, n.user?.organization])
    ).values(),
  ].filter(Boolean);
  const uniqueTemplates = [
    ...new Set(notifications.map((n) => n.template_name).filter(Boolean)),
  ];

  if (loading) return <p>Loading notifications...</p>;

  return (
    <div className="container mt-4">
      <h3 className="mb-4">WhatsApp Notifications</h3>

      <div className="mb-3 bg-EEEEEE">
        <Row className="gy-2">
          <Col md="3">
            <FormGroup>
              <Label for="userSelect" className="form-label-sm fw-bold">
                User
              </Label>
              <Input
                id="userSelect"
                type="select"
                bsSize="sm"
                value={filters.user}
                onChange={(e) =>
                  setFilters({ ...filters, user: e.target.value })
                }
              >
                <option value="">All</option>
                {uniqueUsers.map((u) => (
                  <option key={u.id} value={u.id}>
                    {u.name}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>

          <Col md="3">
            <FormGroup>
              <Label for="orgSelect" className="form-label-sm fw-bold">
                Organization
              </Label>
              <Input
                id="orgSelect"
                type="select"
                bsSize="sm"
                value={filters.org}
                onChange={(e) =>
                  setFilters({ ...filters, org: e.target.value })
                }
              >
                <option value="">All</option>
                {uniqueOrgs.map((o) => (
                  <option key={o.id} value={o.id}>
                    {o.name}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>

          <Col md="3">
            <FormGroup>
              <Label for="templateSelect" className="form-label-sm fw-bold">
                Template
              </Label>
              <Input
                id="templateSelect"
                type="select"
                bsSize="sm"
                value={filters.template}
                onChange={(e) =>
                  setFilters({ ...filters, template: e.target.value })
                }
              >
                <option value="">All</option>
                {uniqueTemplates.map((t) => (
                  <option key={t} value={t}>
                    {t}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>

          <Col md="2">
            <FormGroup>
              <Label className="form-label-sm fw-bold">Date</Label>
              <Input
                type="date"
                bsSize="sm"
                value={filters.date}
                onChange={(e) =>
                  setFilters({ ...filters, date: e.target.value })
                }
              />
            </FormGroup>
          </Col>
        </Row>
      </div>

      <table className="table table-bordered table-hover table-sm">
        <thead className="table-light">
          <tr>
            <th>User</th>
            <th>Organization</th>
            <th>Mobile</th>
            <th>Template</th>
            <th>Parameters</th>
            <th>Sent At</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((n) => (
            <tr key={n.id}>
              <td>{n.user?.name || "—"}</td>
              <td>
                {n.user?.organization
                  ? `${n.user.organization.name} (${n.user.organization.id})`
                  : "—"}
              </td>
              <td>{n.mobile}</td>
              <td>{n.template_name}</td>
              <td>
                {Array.isArray(n.template_params)
                  ? n.template_params.join(", ")
                  : JSON.stringify(n.template_params)}
              </td>
              <td>
                {new Date(n.created_at).toLocaleString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                  hour: "numeric",
                  minute: "2-digit",
                  hour12: true,
                })}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Notifications;
